import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import { Router, withRouter } from 'react-router-dom';
import history from 'Libs/history';

import Routes from 'Views/router';

import NavBar from 'Components/NavBar';
import Footer from 'Components/Footer';

import { createGlobalStyle } from 'styled-components';
import globals from 'Styles/globals.scss';
import normalize from 'normalize.css';

const Globals = createGlobalStyle(globals);
const Normalize = createGlobalStyle(normalize);

import { updateApiStore } from 'Store';

import ErrorPage from 'Views/ErrorPage';
import Api from './libs/analytics/Api';
import $ from 'jquery';

const ScrollToTopStub = ({ children, location: { pathname } }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    if (document.getElementById('firstEle')) {
      document.getElementById('firstEle').focus();
      document.getElementById('firstEle').blur();
      document.body.click();
      
    }
  }, [pathname]);

  return children || null;
};
const ScrollToTop = withRouter(ScrollToTopStub);

const ApiCallerStub = props => {
  useEffect(() => {
    /**
     * @type {string}
     */
    const searchStr = history.location.search;
    let hasId = false;

    if (searchStr) {
      if (searchStr.toLowerCase().indexOf('id=') != -1) {
        hasId = true;
        updateApiStore()
          .then(({ published, id }) => {
            if (published === 'true') {
              Api.DO_NOT_RECORD = false;
              Api.startSession(id).catch(err => {
                console.log(err);
              });
            } else {
              Api.DO_NOT_RECORD = true;
            }
          })
          .catch(err => {
            console.log(err);
            props.setError(true);
          });
      }
    }

    if (hasId == false) {
      const idInPath = (history.location?.pathname || '').replace('/', '');
      let newLocation = `/?id=${idInPath}`;
      if (searchStr) {
        newLocation += searchStr.replace('?', '&');
      }
      location.replace(newLocation);
    }
  }, [props]);

  return <React.Fragment />;
};

const ApiCallerComp = withRouter(ApiCallerStub);

const Main = () => {
  const [error, setError] = useState(false);

  return error ? (
    <ErrorPage />
  ) : (
    <Router history={history}>
      <ScrollToTop>
        <Normalize />
        <Globals />
        <NavBar />
        <Routes />
        <Footer />
      </ScrollToTop>
      <ApiCallerComp setError={setError} />
    </Router>
  );
};

ReactDOM.render(<Main></Main>, document.getElementById('root'));
$(() => {
  $('body').on('click', 'a.external', () => {
    Api.recordAcitity('EXT_CLICK');
  });
});
